import { getMessages } from '../../../../../../store/constants';

export const BROWSER_NOTIFICATIONS_REQUEST_TEXT = getMessages().getText('notifications_request.browser.text');
export const BROWSER_NOTIFICATIONS_REQUEST_LABEL_ALLOW = getMessages().getText('notifications_request.browser.allow');
